// @flow

import React from 'react';
import ListComponent from './list.container';
import type { ACFProps, BorderType } from './types';
import type { ACFThemingOption } from '../../types/acf/themingOption';
import { joinArrayOrGetValue } from '../../helpers';
import {
  SCHEME_DEFAULT_LIGHT,
  SCHEME_DEFAULT,
  BORDER_HERO,
  BORDER_DEFAULT,
} from './constants';

type Props = ACFProps;

const getColorScheme = (backGroundColor: string, variant: ACFThemingOption) => {
  if (variant === BORDER_HERO) {
    return SCHEME_DEFAULT_LIGHT;
  }
  return backGroundColor;
};

const getBorderStyle = (
  variant: BorderType,
  backGroundColor: string,
): BorderType => {
  if (variant === SCHEME_DEFAULT_LIGHT || backGroundColor === SCHEME_DEFAULT) {
    return BORDER_DEFAULT;
  }
  return variant;
};

const ACFList = ({
  background_color,
  collapsible,
  items,
  minimalistic,
  subtitle,
  template,
  title,
  variant,
  override_toggle_labels,
  collapsible_button,
}: Props) => (
  <ListComponent
    border={getBorderStyle(
      joinArrayOrGetValue(variant),
      joinArrayOrGetValue(background_color),
    )}
    colorScheme={getColorScheme(
      joinArrayOrGetValue(background_color),
      joinArrayOrGetValue(variant),
    )}
    title={title}
    listStyle={template}
    subtitle={subtitle}
    items={items || []}
    collapsible={collapsible}
    minimalistic={minimalistic}
    collapsibleButtonTextOverride={override_toggle_labels ? collapsible_button : undefined}
  />
);

ACFList.defaultProps = {
  subtitle: null,
  title: null,
};

export default ACFList;
